import './Contact.css';
import instagramIcon from './assets/Brands/Instagram.svg';
import linkedInIcon from './assets/Brands/Linkedin.svg';
import dribbbleIcon from './assets/Brands/Dribbble.svg';
import behanceIcon from './assets/Brands/Behance.svg';

const Contact = () => {
	return (
		<div className="contact">
			<h1>Kontakt</h1>
			<form spellCheck="false" autocomplete="off">
				<div className="type-of-realization">
					<p>Interesuje mnie:</p>
					<div className="types">
						<div className="type">
							<input
								type="checkbox"
								name="visual identification"
								id="visual-identification-input"
								hidden
							></input>
							<label htmlFor="visual-identification-input">Identyfikacja wizualna</label>
						</div>
						<div className="type">
							<input type="checkbox" name="logo" id="logo-input" hidden></input>
							<label htmlFor="logo-input">LOGO</label>
						</div>
						<div className="type">
							<input type="checkbox" name="website" id="website-input" hidden></input>
							<label htmlFor="website-input">Strona www</label>
						</div>
						<div className="type">
							<input type="checkbox" name="others" id="others-input" hidden></input>
							<label htmlFor="others-input">inne</label>
						</div>
					</div>
				</div>
				<div className="wrapper">
					<div className="input-wrapper">
						<input name="first name" required></input>
						<label>Imię</label>
					</div>
					<div className="input-wrapper">
						<input name="email" required></input>
						<label>Email</label>
					</div>
				</div>
				<div className="textarea-wrapper">
					<textarea
						required
						name="details"
						onInput={(event) => {
							event.target.style.height = 'auto';
							event.target.style.height = event.target.scrollHeight + 'px';
						}}
					></textarea>
					<label>Szczegóły projektu (opcjonalnie)</label>
				</div>
				<button>Wyślij</button>
			</form>
			<div className="socials-and-contact">
				<div className="socials">
					<div className="social">
						<img src={instagramIcon}></img>
					</div>
					<div className="social">
						<img src={linkedInIcon}></img>
					</div>
					<div className="social">
						<img src={behanceIcon}></img>
					</div>
					<div className="social">
						<img src={dribbbleIcon}></img>
					</div>
				</div>
				<div className="contact-data">
					<p>info@markokaczorowski.pl</p>
					<p>tel. 783 249 727</p>
				</div>
			</div>
			<p className="author">&#169;2022 Marko Kaczorowski</p>
		</div>
	);
};

export default Contact;
